function processMarkerEvents(startDates) {
  const events = [];
  let currentDate = new Date(startDates[0].replace(/\\/g, ''));
  
  startDates.forEach((dateStr, index) => {
    if (index === 0) {
      events.push([currentDate.getTime(), "0000"]);
    } else if (!dateStr.startsWith('-') && dateStr.trim() !== '') {
      // Get the last 2 digits for minutes
      const minutes = parseInt(dateStr.slice(-2));
      // Get all digits except last 2 for hours
      const hours = parseInt(dateStr.slice(0, -2)) || 0;
      
      const milliseconds = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000);
      currentDate = new Date(currentDate.getTime() - milliseconds);
      events.push([currentDate.getTime(), "0000"]);
      
      
    }
  });
  
  return events;
}

function processRoutineEvents(startDates, endDates) {
  const events = [];
  
  startDates.forEach((startDateStr, index) => {
    const endDateStr = endDates[index];
    
    if (index === 0) {
      // First event: use the full date-time
      const startDate = new Date(startDateStr.replace(/\\/g, ''));
      const endDate = new Date(endDateStr.replace(/\\/g, ''));
      events.push({start: startDate.getTime(), end: endDate.getTime()});
    } else {
  // Subsequent events: calculate based on time difference
  const prevEvent = events[index - 1];
  const startDiff = parseHHMMSS(startDateStr);
  const endDiff = parseHHMMSS(endDateStr);
  
  const endDate = new Date(prevEvent.start - endDiff);
  const startDate = new Date(endDate - startDiff);
  events.push({start: startDate.getTime(), end: endDate.getTime()});
}
 
  });
  
  return events;
}

function processBedtimeEvents(startDates, endDates) {
  const events = [];
  
  

  startDates.forEach((startDateStr, index) => {
    const endDateStr = endDates[index];
    
    if (index === 0) {
      // First event: use the full date-time
      const startDate = new Date(startDateStr.replace(/\\/g, ''));
      const endDate = new Date(endDateStr.replace(/\\/g, ''));
      events.push({start: startDate.getTime(), end: endDate.getTime()});
    } else {
      // Subsequent events: calculate based on time difference
      const prevEvent = events[index - 1];
      
      if (startDateStr.trim() === '000') {
        // This is a bedtime-only event (no morning time)
        const timeDiff = parseHHMMSS(endDateStr);
        const eventTime = new Date(prevEvent.start - timeDiff);
        events.push({
          start: eventTime.getTime(),
          end: eventTime.getTime() // Same time for start and end
        });
      } else if (endDateStr.trim() === '000') {
        // This is a morning-only event (no bedtime)
        const timeDiff = parseHHMMSS(startDateStr);
        const eventTime = new Date(prevEvent.start - timeDiff);
        events.push({
          start: eventTime.getTime(),
          end: eventTime.getTime() // Same time for start and end
        });
      } else {
        // This is a complete bedtime-to-morning event
        const startDiff = parseHHMMSS(startDateStr);
        const endDiff = parseHHMMSS(endDateStr);
        
        const endDate = new Date(prevEvent.start - endDiff);
        const startDate = new Date(prevEvent.start - endDiff - startDiff);
        events.push({
          start: startDate.getTime(),
          end: endDate.getTime()
        });
      }
    }
    
  });
  
  return events;
}

function formatFinalEvents(events, spotType) {

  
  if (spotType === "Ro" || spotType === "Be") {
    // Reverse the events to get ascending order
    const reversedEvents = [...events].reverse();
    
    const formattedEvents = reversedEvents.map((event, index) => {
      if (index === 0) {
        // First event: use actual timestamps
        return [event.start, event.end];
      } else {
        const prevEvent = reversedEvents[index - 1];
        const startDiff = (event.start - prevEvent.end) / 60000; // Difference in minutes
        const duration = (event.end - event.start) / 60000; // Duration in minutes
        

        
        return [
          formatHHMM(Math.max(0, startDiff)),
          formatHHMM(duration)
        ];
      }
    });
    
    return formattedEvents;
  }  else if (spotType === "Ma" || spotType === "Me") {
    // Reverse the events to get ascending order
    const reversedEvents = [...events].reverse();
    
    const formattedEvents = reversedEvents.map((event, index) => {
      if (index === 0) {
        // First event: use actual timestamp
        return [event[0], "0000"];
      } else {
        const prevEvent = reversedEvents[index - 1];
        const timeDiff = (event[0] - prevEvent[0]) / 60000; // Difference in minutes
        return [formatHHMM(Math.max(0, timeDiff)), "0000"];
      }
    });
    
    return formattedEvents;
  } else {
    return [
      events[events.length - 1],
      ...events.slice(0, -1).reverse().map(event => [
        formatHHMMSS((event[0] - events[events.length - 1][0]) / 1000),
        formatHHMMSS((event[1] - event[0]) / 1000)
      ])
    ];
  }
}

function parseHHMMSS(timeStr) {
  // Special case for '000' timestamp
  if (timeStr === '000') {
    return 0;
  }
  
  const cleanedStr = timeStr.replace(/^0+/, '');
  let hours = 0, minutes = 0;
  
  switch (cleanedStr.length) {
    case 0: // Handle empty string after cleaning
      return 0;
    case 1:
    case 2:
      minutes = parseInt(cleanedStr, 10);
      break;
    case 3:
      hours = parseInt(cleanedStr.substring(0, 1), 10);
      minutes = parseInt(cleanedStr.substring(1), 10);
      break;
    case 4:
      hours = parseInt(cleanedStr.substring(0, 2), 10);
      minutes = parseInt(cleanedStr.substring(2), 10);
      break;
    case 5:
    case 6:
      hours = parseInt(cleanedStr.substring(0, cleanedStr.length - 2), 10);
      minutes = parseInt(cleanedStr.substring(cleanedStr.length - 2), 10);
      break;
    default:
      throw new Error(`Invalid time format: ${timeStr}`);
  }
  
  return (hours * 60 + minutes) * 60 * 1000;
}

function calculateTimeDifferences(events, spotType) {
  if (spotType === "Ma") {
    return events.slice(0, -1).map((timestamp, index) => 
      (timestamp - events[index + 1]) / (60 * 1000)
    );
  } else {
    return events.map(event => (event[1] - event[0]) / (60 * 1000));
  }
}

function formatHHMM(minutes) {
  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);
  return `${String(hours).padStart(2, '0')}${String(mins).padStart(2, '0')}`;
}

function formatHHMMSS(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  return `${String(hours).padStart(2, '0')}${String(minutes).padStart(2, '0')}${String(secs).padStart(2, '0')}`;
}

function calculateAverage(arr) {
  return arr.reduce((a, b) => a + b, 0) / arr.length;
}

function calculateMedian(arr) {
  const sorted = arr.slice().sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);
  if (sorted.length % 2 === 0) {
    return (sorted[middle - 1] + sorted[middle]) / 2;
  }
  return sorted[middle];
}

function calculateMode(arr) {
  const frequency = {};
  let maxFreq = 0;
  let mode = arr[0];

  for (const num of arr) {
    frequency[num] = (frequency[num] || 0) + 1;
    if (frequency[num] > maxFreq) {
      maxFreq = frequency[num];
      mode = num;
    }
  }

  return mode;
}

function parseFrequency(amount, type) {
  if (!amount || !type) {
    return {
      fT: "None",
      fV: "",
      fP: ""
    };
  }

  const frequencyTypes = ["hour", "day", "week", "month", "none"];
  const frequencyType = frequencyTypes[parseInt(type) - 1];
  
  if (!frequencyType || frequencyType === "none") {
    return {
      fT: "None",
      fV: "",
      fP: ""
    };
  }
  
  // Convert amount to string and handle any possible undefined/null cases
  const amountStr = String(amount);
  
  // Check if amount is a fraction
  if (amountStr.includes('/')) {
    const [numerator, denominator] = amountStr.split('/').map(Number);
    return {
      fT: "Multiple Times Per",
      fV: denominator.toString(),
      fP: frequencyType
    };
  } else {
    return {
      fT: "Some time per period",
      fV: amountStr,
      fP: `1:${frequencyType.charAt(0).toUpperCase() + frequencyType.slice(1)}`
    };
  }
}

window.parseIphone = {
  parseIPhoneData: function(data) {
    try {
      // Split the data safely
      const parts = data.split('---').map(part => {
        try {
          return JSON.parse(part);
        } catch (e) {
          // If JSON parse fails, try cleaning the string first
          const cleanedPart = part.replace(/\{\{+/g, '{')
                                 .replace(/\}\}+/g, '}')
                                 .replace(/[^\x20-\x7E]/g, '') // Remove non-printable characters
                                 .replace(/\\n/g, '\n') // Handle newlines
                                 .replace(/\\/g, '\\\\'); // Properly escape backslashes
          try {
            return JSON.parse(cleanedPart);
          } catch (jsonError) {
            console.error("Error parsing cleaned JSON:", jsonError);
            console.log("Problematic data:", cleanedPart);
            throw new Error(`Failed to parse JSON even after cleaning: ${jsonError.message}`);
          }
        }
      });
      
      if (parts.length !== 2) {
        throw new Error(`Expected 2 parts in data, got ${parts.length}`);
      }

      const [part1, part2] = parts;
      
      const spotTitle = part1.ST;
      const spotType = part1.STY;
      const promptQuestion = part1.SP || "";
      const finishPromptQuestion = part1.FP || "";
      
      // Get frequency values for Marker and Routine types
      const frequencyAmount = part1.FA;
      const frequencyType = part1.FN;
      
      // Split the dates and responses, handling potential undefined values
      const startDatesRaw = (part2.StartDates || '').split('\n');
      const endDatesRaw = (part2.EndDates || '').split('\n');
      const startResponsesRaw = (part2.SResponse || '').split('\n');
      const finishResponsesRaw = (part2.FResponse || '').split('\n');

      // Ensure we have at least one date
      if (!startDatesRaw[0]) {
        throw new Error('No start dates found in data');
      }

      // Separate the first date (which is always valid) from the rest
      const firstStartDate = startDatesRaw[0];
      const firstEndDate = endDatesRaw[0];
      const firstStartResponse = startResponsesRaw[0];
      const firstFinishResponse = finishResponsesRaw[0];

      // Filter out negative dates for all event types, excluding the first date
      const startDates = [firstStartDate, ...startDatesRaw.slice(1)
        .filter(date => date.trim() !== '' && parseFloat(date) >= 0)];
      const endDates = [firstEndDate, ...endDatesRaw.slice(1)
        .filter(date => date.trim() !== '' && parseFloat(date) >= 0)];
      
      // For responses, check if there are any negative values, if so drop the last response
      const hasNegativeValues = startDatesRaw.slice(1).some(date => 
        date.trim() !== '' && parseFloat(date) < 0
      );
      
      const startResponses = [
        firstStartResponse,
        ...startResponsesRaw.slice(1, hasNegativeValues ? -1 : undefined)
          .filter(response => response && response.trim() !== '' && !response.includes('{'))
      ];
      const finishResponses = [
        firstFinishResponse,
        ...finishResponsesRaw.slice(1, hasNegativeValues ? -1 : undefined)
          .filter(response => response && response.trim() !== '' && !response.includes('{'))
      ];

      let events = [];

      // Process events based on spot type
      if (spotType === 'Ma' || spotType === 'Me') {
        events = processMarkerEvents(startDates);
      } else if (spotType === 'Ro') {
        events = processRoutineEvents(startDates, endDates);
      } else if (spotType === 'Be') {
        events = processBedtimeEvents(startDates, endDates);
      } else {
        throw new Error("Unknown spot type: " + spotType);
      }
      
      const finalEvents = formatFinalEvents(events, spotType);
      const timeDiffs = calculateTimeDifferences(events, spotType);
      
      const avgT = formatHHMM(calculateAverage(timeDiffs));
      const medT = formatHHMM(calculateMedian(timeDiffs));
      const modT = formatHHMM(calculateMode(timeDiffs));
      
      let parsedData = {
        sT: spotTitle,
        sTy: spotType === 'Me' ? 'Ma' : spotType, // Convert 'Me' to 'Ma' for consistency
        Alt: spotType === 'Me' ? 1 : 0, // Set Alt to 1 for Medicine spots
        d: {
          e: finalEvents,
          avgT: avgT,
          medT: medT,
          modT: modT,
        }
      };

      // Handle different spot types
      if (spotType === 'Ma' || spotType === 'Me') {
        parsedData.d.avgD = "0000";
        // Only add prompt question and values if there is a question
        if (promptQuestion.trim()) {
          parsedData.d.pT = promptQuestion;
          parsedData.d.pV = startResponses.reverse();
        }
        // Add frequency if values exist
        if (frequencyAmount && frequencyType) {
          parsedData.f = parseFrequency(frequencyAmount, frequencyType);
        }
      } else if (spotType === 'Be') {
        const durations = events.map(event => (event.end - event.start) / 60000);    
        // Only add start prompt responses if there is a question
        // Add sleep responses (ratings) to the data structure
          if (part2.SResponse) {
            parsedData.d.sR = part2.SResponse;
          }
        if (promptQuestion.trim()) {
          parsedData.d.sP = {
            [promptQuestion]: startResponses.reverse()
          };
        }
        
        // Store finish prompts as arrays
        if (finishPromptQuestion.trim()) {
          parsedData.d.stP = {
            [finishPromptQuestion]: finishResponses.reverse()
          };
        }
        // For Bedtime type, use BT directly
        if (part1.BT) {
          parsedData.BT = part1.BT;
        }
      } else if (spotType === 'Ro') {
          // Routine type
          const durations = events.map(event => (event.end - event.start) / 60000);
          parsedData.d.avgD = formatHHMM(calculateAverage(durations));
          parsedData.d.medD = formatHHMM(calculateMedian(durations));
          parsedData.d.modD = formatHHMM(calculateMode(durations));
          parsedData.d.avgT = "0000";
          
          // Process start prompt responses if there's a start prompt
          if (part1.SP && part1.SP.trim()) {
            const startResponses = part2.SResponse.split('\n')
              .filter(response => response && response.trim() !== '' && !response.includes('{'));
            
            // If there are negative dates, remove last response
            if (startDatesRaw.some(date => parseFloat(date) < 0)) {
              startResponses.pop();
            }
            
            parsedData.d.sP = {
              [part1.SP]: startResponses
            };
          }
          
          // Process finish prompt responses if there's a finish prompt
          if (part1.FP && part1.FP.trim()) {
            const finishResponses = part2.FResponse.split('\n')
              .filter(response => response && response.trim() !== '' && !response.includes('{'));
            
            // If there are negative dates, remove last response
            if (endDatesRaw.some(date => parseFloat(date) < 0)) {
              finishResponses.pop();
            }
            
            parsedData.d.stP = {
              [part1.FP]: finishResponses
            };
          }
          
          // Add frequency if values exist
          if (part1.FA && part1.FN) {
            parsedData.f = parseFrequency(part1.FA, part1.FN);
          }
        }
      
      return parsedData;

    } catch (error) {
      console.error("Error in parseIPhoneData:", error);
      console.log("Original data:", data);
      throw error;
    }
  }
};

